<template>
  <div id="invDetail">
    <el-row>
      <!-- 设备基本信息 -->
      <div class="paneDivWarp" style="padding-bottom: 45px;">
        <p class="flowP">
          {{ invSn }}
          <span>{{ invInfoTem.timeAgo }}</span>
        </p>
        <div class="flowDivWarp">
          <img v-if="!invInfoTem.online" src="@/assets/images/kisae/flowChart/invOfflineFlow.jpg" alt="" style="width: 100%;">
          <img v-else src="@/assets/images/kisae/flowChart/invByBatFlow.gif" alt="" style="width: 100%;">
          <div class="batteryData flowDataDiv">
            <p>{{ invInfoTem.batteryV }} V</p>
            <p>{{ invInfoTem.batteryA }} A</p>
          </div>
          <div class="machineData flowDataDiv">
            <p>{{ invInfoTem.inverterPower }} W</p>
          </div>
        </div>
      </div>
      <!-- 状态 -->
      <div class="paneDivWarp paneDivStatusWarp">
        <div class="divWarp25">
          <div class="paneDivStatusImg">
            <img v-if="invInfoTem.online" src="@/assets/images/kisae/sense_online.png" alt="">
            <img v-else src="@/assets/images/kisae/sense_offline.png" alt="">
          </div>
          <div class="paneDivStatusP">
            <p>LOAD SENSE</p>
            <p v-if="invInfoTem.online&&invInfoTem.eco==1" class="statusP">OFF</p>
            <p v-else-if="invInfoTem.online&&invInfoTem.eco==2" class="statusP">ON</p>
            <p v-else class="statusP">--</p>
          </div>
        </div>
      </div>
      <!-- 警告 -->
      <div class="paneDivWarp warningWarp">
        <el-table :data="warningList" style="width: 100%" :show-header="false" empty-text="The device has no warning for the time being.">
          <el-table-column width="100">
            <template slot-scope="scope">
              <img :src="scope.row.imgUrl" alt="" style="width: 80px;">
              <!-- <img src="@/assets/images/warningSimpleImg/E02.png" alt=""> -->
            </template>
          </el-table-column>
          <el-table-column prop="question">
            <template slot-scope="scope">
              <span>{{ scope.row.question }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="answer" />
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import i18n from '@/i18n'
import { updateTimeOnlyEn } from '@/utils/updateTime.js'

export default {
  name: '',
  props: {
    invTabPaneInfo: {
      type: Object,
      default: () => { }
    },
    invSn: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      invInfoTem: {
        inverterPower: '--',
        batteryV: '--',
        batteryA: '--',
        timeAgoRes: null,
        timeAgo: null
      },
      warningList: [],
      warningInvInfo: [// 单项逆变器 警告文字
        { key: 'E01', question: 'Input low voltage protection', answer: '1) check if the battery bank is connected correctly;2) check if the inverter is connected correctly;3) check if the single battery in the battery bank is failed/ damaged.' },
        { key: 'E02', question: 'Input high voltage protection', answer: '1) disconnect the load, check if voltage of the battery bank is higher than 32.5V;2) disconnect the load, after 5-10 seconds, then re-connect the load to check if it can output normally.' },
        { key: 'E03', question: 'Short circuit,overload protection, over current of the output', answer: '1) disconnect the load, after 5-10 seconds, then re-connect the load to check if it can output normally;2) disconnect the load, after 5-10 seconds, then re-connect the load,if it cannot output normally, need to return the units to the factory to repair.' },
        { key: 'E04', question: 'High temperature protection', answer: 'disconnect the load, check if the ambient and the shell temperature exceed the requirement of the specification.' },
        { key: 'E06', question: 'Overload warning', answer: 'Check if the connected load is overload, or decrease the load for testing.' },
        { key: 'E07', question: 'High temperature warning', answer: 'check if the ambient and the shell temperature exceed the requirement of the specification.' }
      ],
      timer: null

    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    invTabPaneInfo: {
      handler(newValue, oldValue) {
        // this.invInfoTem = newValue // 把新值赋值给我们的属性数据
        // console.log('watch*********', this.invInfoTem)
        this.MQTT()
      },
      deep: true,
      immediate: true
    },
    language(newValue, oldValue) {
      if (this.invInfoTem.timeAgoRes) this.invInfoTem.timeAgo = updateTimeOnlyEn(this.invInfoTem.timeAgoRes)
    }
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    MQTT() {
      console.log('mqtt**invTem********', this.invTabPaneInfo)
      if (this.invTabPaneInfo.dataFrom == 'api') {
        this.invInfoTem.timeAgoRes = this.invTabPaneInfo.timeAgoRes
        this.invInfoTem.timeAgo = updateTimeOnlyEn(this.invInfoTem.timeAgoRes)
        this.invInfoTem.online = false
      } else if (this.invTabPaneInfo.dataFrom == 'mqtt') {
        if (!this.invTabPaneInfo) return
        this.invInfoTem.timeAgo = 'A Moment Ago'
        this.invInfoTem.timeAgoRes = new Date().getTime()
        this.invInfoTem.altV = this.invInfoTem.altA = this.invInfoTem.batteryV = this.invInfoTem.batteryA = this.invInfoTem.invOutputPower = '--'
        if (!this.invTabPaneInfo.connection) { // 设备状态 0：连接 1：断开
          this.invInfoTem.online = true
        } else {
          this.invInfoTem.online = false
        }
        this.invInfoTem.batteryV = (this.invTabPaneInfo.bat_V / 100).toFixed(2)
        this.invInfoTem.batteryA = (this.invTabPaneInfo.bat_I / 100).toFixed(2)
        if (this.invTabPaneInfo.inverter_Power != 65535) this.invInfoTem.inverterPower = Math.round(this.invTabPaneInfo.inverter_Power * 10)
        this.invInfoTem.eco = this.invTabPaneInfo.eco
        // this.invInfoTem.inverter_I = this.invTabPaneInfo.inverter_I
        var errors = []
        // this.invTabPaneInfo.errorStatus = 1
        this.warningList = []
        if (this.invTabPaneInfo.errorStatus) { // 警告
          errors = this.decimalToBinary(this.invTabPaneInfo.errorStatus)
          // console.log('errors----------', errors)
          errors.forEach((v, i) => {
            if (v == 1) {
              var ii = i + 1
              this.warningList.push({
                imgUrl: require('@/assets/images/warningSimpleImg/E0' + ii + '.png'),
                question: this.warningInvInfo[i].question,
                answer: this.warningInvInfo[i].answer
              })
            }
          })
        }
        if (!this.invInfoTem.online) {
          for (var k in this.invInfoTem) {
            // console.log(k)
            if (k != 'online') {
              this.invInfoTem[k] = '--'
              this.warningList = []
            }
          }
        }
        // console.log('mqtt**invInfoTem********', this.invInfoTem)
      }
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.invInfoTem.timeAgoRes) this.invInfoTem.timeAgo = updateTimeOnlyEn(this.invInfoTem.timeAgoRes)
        }, 60000)
      }
    },
    decimalToBinary(num) { // 十进制转二进制
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (myNum < 10) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      } else if (myNum >= 10 && myNum < 100) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
      // return b
    }

  }
}
</script>

<style lang="scss">
#invDetail{
  .batteryData{
    left: calc(93.9% - 40px);
    top: 63.3%;
  }
  .machineData{
    left: calc(9.8% - 40px);
    top: 63%;
  }
}
</style>
